(function () {
  'use strict';

  /* @ngdoc object
   * @name cabinPerformance
   * @description
   *
   */
  angular
    .module('cabinPerformance', [
      'ui.router'
    ]);
}());
